import { useState } from 'react'

export default function useForm(defaults) {
  const [values, setValues] = useState(defaults)

  function updateValue(e) {
    const { name, type, value: rawValue, checked } = e.target
    let value

    if (type === 'checkbox') {
      // checkbox → boolean
      value = checked
    } else if (type === 'number') {
      // number → integer
      value = parseInt(rawValue, 10)
    } else {
      // everything else → string
      value = rawValue
    }

    setValues(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  return { values, updateValue }
}
